import { useToast } from '@chakra-ui/react';

// Hook for creating toast notifications with Chakra UI v2
export const useAppToast = () => {
  const toast = useToast();

  const showToast = (options) => {
    return toast({
      duration: options.duration || 5000,
      isClosable: options.isClosable !== false,
      position: 'top-right',
      ...options,
    });
  };

  const showSuccessToast = (title, description, options = {}) => {
    return showToast({
      title,
      description,
      status: 'success',
      ...options,
    });
  };

  const showErrorToast = (title, description, options = {}) => {
    return showToast({
      title,
      description,
      status: 'error',
      ...options,
    });
  };

  const showInfoToast = (title, description, options = {}) => {
    return showToast({
      title,
      description,
      status: 'info',
      ...options,
    });
  };

  const showWarningToast = (title, description, options = {}) => {
    return showToast({
      title,
      description,
      status: 'warning',
      ...options,
    });
  };

  return {
    showToast,
    showSuccessToast,
    showErrorToast,
    showInfoToast,
    showWarningToast,
  };
};